import { LearningPlan } from "src/app/_models/LearningPlan";
import { LearningPlanState } from "./learning-plan.state";

export function getPanelState(state: LearningPlanState, action: {state: LearningPlan[], courseId: number}): LearningPlan[]{
	const { courseId } = action;
	const { panelState } = state;

	if(state.course !== courseId || panelState.length === 0){
		return setInitialState(action.state);
	}
	
	if (panelState.length > 0 && action.state.length > 0) {
		return updatePanelState(state, action);
	}

	return panelState;
}

export function setInitialState(state: LearningPlan[]): LearningPlan[] {
	const firstRecord = state[0];
	const secondRecord = state[1];

	return state.map(record => ({
		...record,
		expanded: (
			record.categoryDescription === firstRecord.categoryDescription ||
			record.categoryDescription === secondRecord.categoryDescription),
		newCurrentLevel: record.currentLevel
	}));
}

export function updatePanelState(
	state: LearningPlanState, action: {state: LearningPlan[], courseId: number}
): LearningPlan[] {

	const firstRecord = action.state[0].categoryDescription;
	const secondRecord = action.state[1].categoryDescription;

	return action.state.map(item => {
		const itemPrevState = state.panelState.find(i2 => i2.categoryDescription === item.categoryDescription);

		//if current item is not on the previous state, check whether it is on the first or second record and set expanded to true by default
		return {...item, 
			newCurrentLevel: item.currentLevel, 
			expanded: (itemPrevState !== undefined ? itemPrevState.expanded : 
																	((item.categoryDescription === firstRecord || item.categoryDescription === secondRecord) ? true : false))}		
	});
}
